// extracted by mini-css-extract-plugin
export default {"loading-indicator":"loading-indicator-yM1js5W","white":"white-oiHARJJ","icon":"icon-xLn2QVM","grey":"grey-cKHVsVb","icon-wrapper":"icon-wrapper-b4OY0jj","spin":"spin-SI12pju"};